module.exports = __webpack_public_path__ + "media/images/emblems/Davos_wappen-5bdd9861b9b354b4627cb79dcea96556.svg";